module.exports = __webpack_public_path__ + "static/overdata-8b22ccc55c9cd6ac6103cbf55303495c.png";